// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"cf8da25d","3919":"99954768","4481":"8194968f","5079":"cf8da25d","7876":"cf8da25d"}[chunkId] + ".chunk.css";
};